export enum DrawerMode {
  Side = 'side',
  Over = 'over',
  Push = 'push'
}
